import { createContext, useContext } from 'react'
import { App as AntDesignApp } from 'antd'
import handleError from '@/utils/handleError'

const AntdAppContext = createContext(null)

export const AntdAppProvider = ({ children }) => {
	const staticFunctionAntd = AntDesignApp.useApp()

	const handleErrorWithAntd = (staticFunctionAntd) => (error, notify, filename, args) => {
		return handleError(error, notify, filename, args, staticFunctionAntd)
	}

	const contextValue = {
		...staticFunctionAntd,
		handleError: handleErrorWithAntd(staticFunctionAntd),
	}

	return <AntdAppContext.Provider value={contextValue}>{children}</AntdAppContext.Provider>
}

export const useAntdApp = () => {
	return useContext(AntdAppContext)
}
